<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full md:max-w-md" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                    <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                </div>
                <div class="mt-2">
                    <h3 class="text-lg mb-4 leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                        Electronic Communication
                    </h3>
                </div>
                <div class="px-5 pt-4 pb-1 border-t border-gray-200">
                    <p class="mb-2 font-medium text-sm">
                        Do you agree to electronic communication?
                    </p>

                    <div v-html="confirmDecline ? declinedTemplate : template" class="overflow-y-auto max-h-96 p-4 mb-4 border-2 border-gray-200 rounded-lg" />

                    <label v-if="! confirmDecline" class="flex items-center justify-center md:justify-start mb-4 text-xs">
                        <input type="checkbox" class="form-control mr-2" :value="true" v-model="electronicConsentCheckbox" />
                        &nbsp;I have read and agree to the terms and conditions.*
                    </label>

                    <div class="flex flex-col md:flex-row-reverse justify-between space-y-2 md:space-y-0">
                        <button type="button"
                            @click="confirmDecline ? accept(true) : accept(false)"
                            :class="{[
                                `text-white px-3 text-xs py-2 md:ml-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true,
                                'cursor-not-allowed': ! electronicConsentCheckbox && ! confirmDecline
                            }">
                            Opt in to E-Communication
                        </button>
                        <div v-if="loading" class="hidden md:inline-block">
                            <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                        </div>
                        <button v-if="! electronicConsentCheckbox" type="button"
                            @click="confirmDecline ? decline() : confirmDecline = true"
                            :class="{[`text-black px-3 text-xs py-2 md:mr-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-300 hover:bg-gray-400 focus:ring-gray-200`]: true}">
                            Decline E-Communications
                        </button>
                        <div v-if="loading" class="md:hidden flex-initial flex justify-center items-center">
                            <i :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Mixins from '../../mixins';
    import ElectronicConsent from "../ElectronicConsent.vue";

    export default {
        components: {ElectronicConsent},
        mixins: [Mixins],

        props: ['show', 'accountId', 'template', 'declinedTemplate'],

        watch: {
            show: {
                immediate: true,
                handler: function (show, oldShow) {
                    if (show && ! oldShow) {
                        this.gtagEvent('electronic-consent-requested');

                        this.viewed();
                    } else if (! show && oldShow) {
                        this.checked = false;
                        this.loading = false;
                    }
                }
            }
        },

        data() {
            return {
                checked: false,
                error: false,
                confirmDecline: false,
                electronicConsentCheckbox: false,
                loading: false
            }
        },

        methods: {
            viewed() {
                this.$http.post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/viewed`, { source: 'econsent-popup' });
            },

            accept(override = false) {
                if (! override && ! this.electronicConsentCheckbox) return;

                if (this.loading) return;

                this.loading = true;

                this.gtagEvent(
                    ! override
                        ? 'electronic-consent-accepted'
                        : 'electronic-consent-accepted-from-second-chance'
                );

                this.$http
                    .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/${! override ? 'accepted' : 'accepted-from-second-chance'}`, { source: 'econsent-popup' })
                    .then(() => {
                        console.log(this.$root.$refs.app.settings.ecommunication_agreement.required);

                        this.$root.$refs.app.settings.ecommunication_agreement.required = false;

                        console.log(this.$root.$refs.app.settings.ecommunication_agreement.required);

                        setTimeout(() => this.$emit('accepted'), 1000);
                    }, () => this.loading = false);
            },

            decline() {
                if (this.loading) return;

                this.loading = true;

                this.gtagEvent('electronic-consent-declined');

                this.$http
                    .post(`${this.$root.$refs.app.consumerPortalBaseUrl}/api/ecommunication-consent/${this.accountId}/declined`, { source: 'econsent-popup' })
                    .then(() => {
                        setTimeout(() => this.$emit('declined'), 1000);
                    }, () => this.loading = false);
            }
        }
    }
</script>
